import {ISymbolStateConfig, StateReelSymbol} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {IReelStartSpinData, IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {ReelEvent} from "@nolimitcity/slot-game/bin/core/reel/event/ReelEvent";
import {TimelineLite, TweenLite} from "gsap";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {HorribleHeroesSpinReelPartAnimator} from "./spinReel/HorribleHeroesSpinReelPartAnimator";
import {HorribleHeroesParsedGameData} from "../server/data/HorribleHeroesParsedGameData";
import {HorribleHeroesGameConfig} from "../HorribleHeroesGameConfig";
import {HorribleHeroesParsedInitData} from "../server/data/HorribleHeroesParsedInitData";
import {SpinReelController} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {HorribleHeroesSymbolM} from "../symbols/HorribleHeroesSymbolM";
import {HorribleHeroesGameModuleConfig} from "../HorribleHeroesGameModuleConfig";
import {HorribleHeroesReelSymbol} from "../symbols/HorribleHeroesReelSymbol";
import {HorribleHerosXSymbol} from "../symbols/HorribleHerosXSymbol";
import {HorribleHeroesGameMode} from "../HorribleHeroesGameMode";
import {SymbolUtil} from "../utils/SymbolUtil";
import {IBetWayWinData} from "@nolimitcity/slot-game/bin/core/server/data/IServerData";
import {Helper} from "@nolimitcity/slot-game/bin/core/utils/Helper";
import {SpinReelEvent} from "@nolimitcity/slot-game/bin/game/reel/spinreel/SpinReelEvent";
import {HorribleHeroesSymbolMX} from "../symbols/HorribleHeroesSymbolMX";
import {StateMatrix} from "../utils/StateMatrix";
import {TrailReelSymbol} from "../symbols/TrailReelSymbol";

export class HorribleHeroesReelController extends SpinReelController {
    public static readonly SYM_SIZE: { [reelSize: number]: { height: number, padding: number } } = {
        1: {height: 588, padding: 0},
        4: {height: 147, padding: 0},
        5: {height: 117.6, padding: 0},
        6: {height: 98, padding: 0},
        7: {height: 84, padding: 0},
        8: {height: 73.5, padding: 0},
    };
    public static isResponseReceived: boolean = false;
    public static isMayhemMode: boolean = false;
    public static isLockNLoad: boolean = false;
    public static xHighlighAnimPlayed: boolean[] = [false, false, false, false, false];
    public _reelSize: number;
    private xWayExpand: boolean[] = [false, false, false, false, false];
    private gameData: HorribleHeroesParsedGameData;
    private _finalXReelSize: number;
    private _trailingSym: string = "";

    // #331
    private static doPartialWin(symbolStates: StateMatrix<string>, reelId: number, state: ISymbolStateConfig): void {
        const reelCoords: [number, number][] = symbolStates.getCoordinatesWithStateInReel(reelId, state.keyword);

        for (let coords of reelCoords) {
            let sym: HorribleHeroesReelSymbol = (Reels.getSymbol(coords[0], coords[1])! as HorribleHeroesReelSymbol);
            if (sym.symName.indexOf("MX") > -1) {
                //#544
                (sym as HorribleHeroesSymbolMX).partailHighLight();
            }
            if (sym.symName.indexOf("X") === -1) {
                sym.partialWin();
            }
        }
    }

    // #569
    private static stopPartialHighlight(symbolStates: StateMatrix<string>, reelId: number, state: ISymbolStateConfig): void {
        const reelCoords: [number, number][] = symbolStates.getCoordinatesWithStateInReel(reelId, state.keyword);
        for (let coords of reelCoords) {
            let sym: HorribleHeroesReelSymbol = (Reels.getSymbol(coords[0], coords[1])! as HorribleHeroesReelSymbol);
            //#569 to stop highlight
            sym.stopPotentialWin();
        }
    }

    // #331
    private static doPartialDim(symbolStates: StateMatrix<string>, reelId: number, state: ISymbolStateConfig): void {
        const reelCoords: [number, number][] = symbolStates.getCoordinatesWithStateInReel(reelId, state.keyword);

        for (let coords of reelCoords) {
            let sym: HorribleHeroesReelSymbol = (Reels.getSymbol(coords[0], coords[1])! as HorribleHeroesReelSymbol);
            //#502
            if (sym.symName.indexOf("MX") > -1) {
                (sym as HorribleHeroesSymbolMX).setDimDown();
            }
            if ((sym.symName.indexOf("X") === -1 && sym.symName.indexOf("S") === -1)) {
                sym.changeState({
                    state: state
                });
            }
        }
    }

    private static moveReelOnTopOnSpinStart(): void {
        for (let i = 0; i <= 4; i++) {
            Reels.getReel(i)!.view.parent.addChild(Reels.getReel(i)!.view);
        }
    }

    public startSpin(data: IReelStartSpinData, previousDelay: number): number {
        HorribleHeroesReelController.moveReelOnTopOnSpinStart();
        HorribleHeroesReelController.xHighlighAnimPlayed[this._reelId] = false;
        return super.startSpin(data, previousDelay);
    }

    /**
     * @description To re-order the symbols so that Sand W stays on top.
     */
    public reOrderSymbols(): void {
        let sym: StateReelSymbol;
        const symbols: string[] = ["S", "W"];

        symbols.forEach((value: string) => {
            for (let i = 0; i < this._stopReelSet.length; i++) {
                if (this._stopReelSet[i] === value) {
                    sym = this.findSymbol(i - 1)!;
                    sym && this.addChildOnView(sym);
                }
            }
        });
    }

    public convertMayHemModeStacks(newSymName: string, stackSize: number, stackPos: number, mSize: number): void {
        let highSymName = newSymName;
        let symIndexStack = stackPos + 1 - (stackSize - 1);
        for (let i: number = 0; i < stackSize; i++) {
            if (newSymName === "MX") {
                highSymName = "MX_" + (stackSize) + '*' + i;
            }
            const newSymbol: StateReelSymbol = this.addNewSymbol(highSymName);

            const removedSymbolArr = this.allSymbols.splice(symIndexStack + i, 1, newSymbol);
            this.removeSymbol(removedSymbolArr[0]);
            this.updateStackedSymbols(newSymbol, this.allSymbols[symIndexStack + i - 1], 1, true);
            this._reelView.addChild(newSymbol); // move to top

            this.allSymbols[symIndexStack + i].symHeight = 148 * stackSize;
            (<HorribleHeroesSymbolMX>this.allSymbols[symIndexStack + i]).patchMultiplier(stackSize * mSize);
            if (stackSize == 2) {
                this.allSymbols[symIndexStack + i].y = ((symIndexStack) * 148);
            } else if (stackSize == 3) {
                this.allSymbols[symIndexStack + i].y = ((symIndexStack) * 148) + 148 / 2;
            } else {
                this.allSymbols[symIndexStack + i].y = (symIndexStack * 148) + 148;
            }
        }
    }

    public hideOverFlowSyms(visibleIndices: number[]): void {
        if (this.gameData) {
            //#550 as reelsize is reset on spin while server data is reset on Fs starts
            if (this._reelSize > 4) {
                visibleIndices = [1, 2, 3, 4, 5];
                if (this._reelSize === 6) {
                    visibleIndices = [1, 2, 3, 4, 5, 6];
                } else if (this._reelSize === 8) {
                    visibleIndices = [1, 2, 3, 4, 5, 6, 7, 8];
                }
            }
        }
        this.allSymbols.forEach((symbol, index) => {
            if (visibleIndices.indexOf(index) == -1) {
                symbol.visible = false;
            }
        })
    }

    public playPartialWinAnimation(isQuickStop: boolean): void {
        if (!(this.gameData!.betWins.length > 0) || this._reelId < 2) {
            return;
        }

        const winState: ISymbolStateConfig = HorribleHeroesGameConfig.instance.SYMBOL_STATES.win!,
            noWinState: ISymbolStateConfig = HorribleHeroesGameConfig.instance.SYMBOL_STATES.noWin!;
        let symbolStates: StateMatrix<string> = SymbolUtil.createSymbolStateMatrixFromBetWins(
            <IBetWayWinData[]>this.gameData!.betWaysBeforeXWays!,
            noWinState.keyword,
            winState.keyword);
        //#569
        if (isQuickStop) {
            for (let reelId: number = 0; reelId <= this._reelId; reelId++) {
                HorribleHeroesReelController.stopPartialHighlight(symbolStates, reelId, winState);
            }
        } else {
            //#569 to not play if quickStop
            if (!isQuickStop) {
                if (this._reelId === 2) {
                    for (let reelId: number = 0; reelId <= this._reelId; reelId++) {
                        HorribleHeroesReelController.doPartialWin(symbolStates, reelId, winState);
                        HorribleHeroesReelController.doPartialDim(symbolStates, reelId, noWinState);
                    }
                } else {
                    HorribleHeroesReelController.doPartialWin(symbolStates, this._reelId, winState);
                    HorribleHeroesReelController.doPartialDim(symbolStates, this._reelId, noWinState);
                }
            }
        }
    }

    /**
     * @inheritDoc
     * @param data
     */
    public onGameDataParsed(data: HorribleHeroesParsedGameData): void {
        super.onGameDataParsed(data);
        this.xWayExpand = data.isXWayExpanded;
        this.gameData = data!;
        if (this.gameData.mode === HorribleHeroesGameMode.FREESPIN_MID) {
            HorribleHeroesReelController.isLockNLoad = true;
        } else {
            HorribleHeroesReelController.isLockNLoad = false;
        }
        //#434
        HorribleHeroesReelController.isResponseReceived = true;
        const isNextModeFS: boolean = (this.gameData.nextMode !== HorribleHeroesGameMode.NORMAL);
        if (data.isSuperActivatedSpin && isNextModeFS && !data.superFSTriggered) {
            HorribleHeroesReelController.isMayhemMode = true;
            EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {
                reelSetName: "SUPERFS_REELSET",
                reelSetPosition: 2
            }));
            this._nextFullReelSet = Helper.getReelSet("SUPERFS_REELSET", this._reelId);
        }
    }

    public stopSpin(stopData: IReelStopSpinData, previousStopTime: number): number {
        let _this = this;
        this._reelPartAnimator.isQuickStop = stopData.quickStop;
        this._reelPartAnimator.isFastSpin = stopData.fastSpin;
        this._spinStopOffset = stopData.spinStopOffset;
        // Quick stop stopping reel
        if (this.currentState === ReelAnimationState.STOP_SPIN) {
            return this._spinReelPartAnimator.getStopTime(this._stopCounter - 1, false) + this.currentSpinStepLeftTime;
        }
        // Don't need to restore spin speed if quick stop near win?
        if (stopData.active) {
            let stopTimeTotal = this._spinReelPartAnimator.getStopTime(this._symNumTotal + this._spinStopOffset - 1, this.hasNearWin());
            if (this._reelPartAnimator.isQuickStop) {
                this._addedStopDelay = 0;
            }
            let stopTimerDelay = Math.max(0, previousStopTime + this.getStopDelayDelta(stopData) + this._addedStopDelay - stopTimeTotal);
            this._addedStopDelay = 0;
            if (this._reelStopDelayTimer && this._reelStopDelayTimer.isActive()) {
                // quick stop.
                let timelineLeftTime = this._reelStopDelayTimer.totalDuration() - this._reelStopDelayTimer.time();
                if (stopTimerDelay >= timelineLeftTime) {
                    return timelineLeftTime + stopTimeTotal;
                }
                this._reelStopDelayTimer.pause();
                this._reelStopDelayTimer.kill();
            }
            this._reelStopDelayTimer = TweenLite.to(this, stopTimerDelay, {
                onComplete: function () {
                    return _this.clearStopDelay();
                }
            });

            if (this._reelPartAnimator.isFastSpin) {
                stopTimeTotal = 0;
            }
            return stopTimerDelay + stopTimeTotal + this.currentSpinStepLeftTime;
        } else {
            // If reel not active we fake a spin stopped so it actually send the event.
            EventHandler.dispatchEvent(new GameEvent(ReelEvent.REEL_STOP_SPIN_ANIMATION_COMPLETE, {
                reelId: this._reelId,
                fastSpin: this._reelPartAnimator.isFastSpin,
                quickStop: this._reelPartAnimator.isQuickStop,
                active: false
            }));
            return previousStopTime;
        }
    }

    /**
     * @description Either Xway is replaced Or the only infected Symbol Or stacked Infected Symbols(not having X )
     * @param symToReplace - symName,
     * @param mysterySymbolSize -length
     * @param positionId -position on reel
     * @param finalReelSize -reelSize
     * @param isInfectious -optional boolean
     * @param isStack -optional boolean
     */
    public revealXwaySym(symToReplace: string, mysterySymbolSize: number, positionId: number, finalReelSize: number, isInfectious?: boolean, isStack?: boolean, isRestore?: boolean): void {
        let totalNumOfSyms = 4 + (mysterySymbolSize) + 1; //4 visible + mysterySymbolSize-1 +1 top+1 bottom
        this.parseReelSize(finalReelSize);
        let HIGHMSYMS = ["M1", "M2", "M3", "M4", "M5", "S", "X"];
        let LOWSYMS = HorribleHeroesGameConfig.instance.LOWSYMS;
        let mysterySymbolIdInStopSymbols = positionId + 1;
        const symbolHeight: number = HorribleHeroesReelController.SYM_SIZE[this._reelSize].height;
        let highSymName = symToReplace;
        if (isStack) {
            totalNumOfSyms = 4 + (2 * mysterySymbolSize);
        }
        // Replace symbol and add more symbols
        for (let i: number = 0; i < mysterySymbolSize; i++) {
            if (HIGHMSYMS.indexOf(symToReplace) !== -1) {
                highSymName = symToReplace + "_" + (mysterySymbolSize) + '*' + i;
            }
            const newSymbol: StateReelSymbol = this.addNewSymbol(highSymName);
            let mysterID = mysterySymbolIdInStopSymbols;
            if (i !== 0) {
                mysterID = mysterySymbolIdInStopSymbols + i;
            }
            if (LOWSYMS.indexOf(symToReplace) !== -1 || isRestore) {
                if (i == 0) {
                    continue;
                }
                this.addAndRemoveSyms(i, newSymbol, mysterID, 0);
            } else {
                if (i == 0) {
                    this.addAndRemoveSyms(i, newSymbol, mysterID, 1);
                } else {
                    this.addAndRemoveSyms(i, newSymbol, mysterID, 0);
                }
            }

            const lastIndex = mysterySymbolIdInStopSymbols + mysterySymbolSize - 1;
            this.updateStackSyms(HIGHMSYMS, symToReplace, mysterySymbolSize, mysterySymbolIdInStopSymbols, newSymbol, i, lastIndex);
            this._reelView.addChild(newSymbol); // move to top
        }
        this.resetAllSizes(HIGHMSYMS, symToReplace, symbolHeight, mysterySymbolSize, mysterySymbolIdInStopSymbols, isInfectious, isStack);
    }

    public replaceWithInfectedX(symToReplace: string, infectedPos: number, mysterySymbolSize: number, reelSize: number, isAbort?: boolean) {
        const tl = new TimelineLite();
        this.parseReelSize(reelSize);
        const newSymbol: StateReelSymbol = this.addNewSymbol(symToReplace);
        // move to top
        this._reelView.addChild(newSymbol);
        const symbolHeight: number = HorribleHeroesReelController.SYM_SIZE[this._reelSize].height;
        const removedSymbolArr = this.allSymbols.splice(infectedPos, 1, newSymbol);
        newSymbol.y = removedSymbolArr[0].y;
        newSymbol.symHeight = removedSymbolArr[0].symHeight;
        this.removeSymbol(removedSymbolArr[0]);
        (<HorribleHerosXSymbol>Reels.getSymbol(this.reelId, infectedPos - 1))!.setMayhemMode(this.gameData.isSuperActivatedSpin && !this.gameData.superFSTriggered);
        (<HorribleHerosXSymbol>Reels.getSymbol(this.reelId, infectedPos - 1))!.updateBackground(symbolHeight, true, mysterySymbolSize, isAbort);
        //0.2
        if (!isAbort) {
            tl.add(() => {

            }, 0.2);
        }
        return tl;
    }

    public conversionXwaySym(symToReplace: string, mysterySymbolSize: number, positionId: number, finalReelSize: number, isInfectious?: boolean, isStack?: boolean): void {
        this.parseReelSize(4 + mysterySymbolSize - 1);
        const HIGHMSYMS = ["M1", "M2", "M3", "M4", "M5", "S", "B", "MX"];
        const mysterySymbolIdInStopSymbols = positionId + 1;
        const symbolHeight: number = HorribleHeroesReelController.SYM_SIZE[this._reelSize].height;
        let highSymName = symToReplace;
        // Replace symbol and add more symbols
        for (let i: number = 0; i < mysterySymbolSize; i++) {
            if (HIGHMSYMS.indexOf(symToReplace) !== -1) {
                highSymName = symToReplace + "_" + (mysterySymbolSize) + '*' + i;
            }
            const newSymbol: StateReelSymbol = this.addNewSymbol(highSymName);
            let mysterID = mysterySymbolIdInStopSymbols;
            if (i !== 0) {
                mysterID = mysterySymbolIdInStopSymbols + i;
            }
            newSymbol.visible = true;
            this.addAndRemoveSyms(i, newSymbol, mysterID, 1);

            this.updateStackSyms(HIGHMSYMS, symToReplace, mysterySymbolSize, mysterySymbolIdInStopSymbols, newSymbol, i, mysterySymbolIdInStopSymbols + mysterySymbolSize - 1);
            this._reelView.addChild(newSymbol); // move to top
        }
        this.resetAllSizes(HIGHMSYMS, symToReplace, symbolHeight, mysterySymbolSize, mysterySymbolIdInStopSymbols, isInfectious, isStack);
        const visibleIndices: number[] = [];
        for (let i = 1; i <= finalReelSize; i++) {
            visibleIndices.push(i);
        }
        this.hideOverFlowSyms(visibleIndices)
    }

    public playXPotentialWinAnimation(isQuickStop: boolean): void {
        let count: number = 0;
        const xWaysSymbolMayGiveWinPositions: boolean[][] = this.gameData.getPotentialSymbolPostions;
        const tl: TimelineLite = new TimelineLite();
        let sizeAfterMystery: number = 4;
        if (this._reelId === 0) {
            return;
        }
        if (!xWaysSymbolMayGiveWinPositions[0]) {
            return;
        }

        if (this.gameData.getXWaySymbolMayGiveWin) {
            xWaysSymbolMayGiveWinPositions.forEach((pos: boolean[], i: number) => {
                pos.forEach((mayWin: boolean, j: number) => {
                    //#487

                    if ((((i <= this._reelId)) || (this.reelId == 2 && i == 2)) && !HorribleHeroesReelController.xHighlighAnimPlayed[i]) {
                        //#490
                        if (mayWin) {
                            if (this.xWayExpand[i] && this.gameData.XSymbolPositions[i] > -1) {
                                sizeAfterMystery = 4 + this.gameData.mysterySymbolSizes[i] - 1;
                                if (j > this.gameData.XSymbolPositions[i]) {
                                    j = j + this.gameData.mysterySymbolSizes[i] - 1;
                                }
                            } else {
                                sizeAfterMystery = 4;
                            }
                            const sym: StateReelSymbol = Reels.getSymbol(i, j)!;
                            if (sym! && sym!.symName !== "X" && j !== this.gameData.XSymbolPositions[i]) {
                                count++;
                                if (isQuickStop) {
                                    count = 0;
                                }
                                tl.add(() => {
                                    if ((Reels.getSymbol(i, j)! as HorribleHeroesReelSymbol)) {
                                        (Reels.getSymbol(i, j)! as HorribleHeroesReelSymbol)!.playHighLightWin(true);
                                    }
                                }, 0.02 * count);
                            }
                        }
                        if (j === 3) {
                            HorribleHeroesReelController.xHighlighAnimPlayed[i] = true;
                        }
                    }
                });
            });
        }
    }

    /**
     * @description To expand X symbols that will be replaced
     * @param newSymName - symName,
     * @param mysterySymbolSize -length
     * @param positionId -position on reel
     * @param reelSize -reelSize
     * @param isInfectious
     */
    public addExpandingSymbols(newSymName: string, mysterySymbolSize: number, positionId: number, reelSize?: number, isInfectious?: boolean): void {
        const HIGHMSYMS = HorribleHeroesGameConfig.instance.HIGHMSYMS;
        let StackSyms = HIGHMSYMS.concat("X");
        let highSymName = newSymName;
        if (reelSize) {
            this.parseReelSize(reelSize);
        } else {
            this.parseReelSize(4 + mysterySymbolSize - 1);
        }

        const symbolHeight: number = HorribleHeroesReelController.SYM_SIZE[this._reelSize].height;
        const mysterySymbolIdInStopSymbols: number = positionId + 1;
        // Replace symbol and add more symbols
        for (let i: number = 0; i < mysterySymbolSize; i++) {

            if (HIGHMSYMS.indexOf(newSymName) !== -1 || newSymName == "X") {
                highSymName = newSymName + "_" + (mysterySymbolSize) + '*' + i;
            }
            const newSymbol: StateReelSymbol = this.addNewSymbol(highSymName);
            if (i === 0) {
                const removedSymbolArr = this.allSymbols.splice(mysterySymbolIdInStopSymbols, 1, newSymbol);
                this.removeSymbol(removedSymbolArr[0]);
            } else {
                this.allSymbols.splice(mysterySymbolIdInStopSymbols + i, 0, newSymbol);
                const removedSymbol: StateReelSymbol = this.allSymbols.pop()!;
                this.removeSymbol(removedSymbol);
            }
            this.updateStackSyms(StackSyms, newSymName, mysterySymbolSize, mysterySymbolIdInStopSymbols, newSymbol, i, positionId + mysterySymbolSize);
            this._reelView.addChild(newSymbol); // move to top
        }
        (<HorribleHeroesSpinReelPartAnimator>this._reelPartAnimator).setAllSymbols(this.allSymbols.map(s => s!));
        (<HorribleHeroesSpinReelPartAnimator>this._reelPartAnimator).resetSize(symbolHeight, true, mysterySymbolIdInStopSymbols, mysterySymbolSize);
        (<HorribleHerosXSymbol>Reels.getSymbol(this._reelId, mysterySymbolIdInStopSymbols))!.updateBackground(symbolHeight * mysterySymbolSize, isInfectious);
        this.gameData && (<HorribleHerosXSymbol>Reels.getSymbol(this._reelId, mysterySymbolIdInStopSymbols))!.setMayhemMode(this.gameData.isSuperActivatedSpin && !this.gameData.superFSTriggered);
        //#335
    }

    /**
     * @description addExtraExpandingSymbols When X is infectious on same reel
     * @param newSymName - string,
     * @param mysterySymbolSize -length
     * @param positionId - index,
     * @param finalReelSize - reelSizeAfter,
     * @param positionsExpandedSyms - positionsExpandedSyms (on each reel index of infected /X symbol considering actual length,
     */
    public addExtraExpandingSymbols(newSymName: string, mysterySymbolSize: number, positionId: number, finalReelSize: number, positionsExpandedSyms: number[][], alreadyExpanded?: boolean): void {
        const stackSyms = HorribleHeroesGameConfig.instance.HIGHMSYMS.concat(["X"]);
        this.parseReelSize(finalReelSize);
        const symbolHeight: number = HorribleHeroesReelController.SYM_SIZE[this._reelSize].height;
        const mysterIds = this.checkIfMysteryIndex(positionsExpandedSyms[this.reelId][0], mysterySymbolSize); //x
        const mysterIds2 = this.checkIfMysteryIndex(positionsExpandedSyms[this.reelId][1], mysterySymbolSize); //infected symbol

        for (let i = 0; i < this.allSymbols.length; i++) {
            /* to proceed with positions which requires to be expanded */
            if (i > 0 && i < finalReelSize + 1) {
                if (((mysterIds.indexOf(i) !== -1 || mysterIds2.indexOf(i) !== -1))) {
                    if ((positionsExpandedSyms[this.reelId][0] !== i - 1 || !alreadyExpanded) && (i == mysterIds[0] || i == mysterIds2[0])) { //stack sym indices
                        this.addStackSyms(newSymName, finalReelSize, mysterySymbolSize, i);
                        this.allSymbols[i].visible = true;
                    } else if ((HorribleHeroesGameConfig.instance.LOWSYMS.indexOf(newSymName) !== -1) || (alreadyExpanded && (HorribleHeroesGameConfig.instance.LOWSYMS.indexOf(newSymName!) !== -1 && mysterIds2.indexOf(i) == -1))) {
                        this.allSymbols[i].y = ((i - 1) * symbolHeight) + symbolHeight / 2;
                        this.allSymbols[i].visible = true;
                    } else if (stackSyms.indexOf(newSymName) !== -1 && mysterIds2.indexOf(i) == -1) {
                        if (this.allSymbols[i]!.symName.split("_")[1]) {
                            if (mysterySymbolSize == 2) {
                                this.allSymbols[i].y = ((mysterIds[0]) * symbolHeight);
                            } else {
                                this.allSymbols[i].y = (mysterIds[0] * symbolHeight) + symbolHeight / 2;
                            }
                        }
                        const xSymbol = Reels.getSymbol(this._reelId, mysterIds[0])! as HorribleHerosXSymbol;
                        if (newSymName === "X" && xSymbol.symName.indexOf("X") > -1 && xSymbol.symName.indexOf("M") === -1) {
                            xSymbol!.updateBackground(symbolHeight * mysterySymbolSize, true);
                            xSymbol!.setMayhemMode(this.gameData.isSuperActivatedSpin && !this.gameData.superFSTriggered);
                            //#335
                        }
                        this.allSymbols[i].symHeight = symbolHeight * mysterySymbolSize;
                        const sym = Reels.getSymbol(this._reelId, i - 1)!;
                        if (sym && sym!.symName.indexOf("M") > -1) {
                            //#339
                            (<HorribleHeroesSymbolM>sym)!.patchMultiplier(mysterySymbolSize);
                        }
                        this.allSymbols[i].visible = true;
                    }
                } else {
                    this.allSymbols[i].y = ((i - 1) * symbolHeight) + symbolHeight / 2;
                    this.allSymbols[i].visible = true;
                }
                this.allSymbols[i].symHeight = symbolHeight * ((this.allSymbols[i].symName.indexOf("*") > -1) ? (mysterySymbolSize) : 1);
            } else {
                this.allSymbols[i].y = ((i - 1) * symbolHeight) + symbolHeight / 2;
                this.allSymbols[i].symHeight = symbolHeight;
                //#377 whiteframe and blank space
            }
        }
        if (newSymName === "X") {
            (<HorribleHerosXSymbol>Reels.getSymbol(this._reelId, mysterIds2[0]))!.updateBackground(symbolHeight * mysterySymbolSize, true);
        }
    }

    /**
     * @description finds out the index of mysterySymbols on reel.
     * @param mysterySymbolIdInStopSymbols - index,
     * @param mysterySymbolSize -length
     */
    public checkIfMysteryIndex(mysterySymbolIdInStopSymbols: number, mysterySymbolSize: number): number[] {
        let mysterySymIds = [];
        for (let i = 0; i < mysterySymbolSize; i++) {
            mysterySymIds.push(mysterySymbolIdInStopSymbols + 1 + i);
        }
        return mysterySymIds;
    }

    public replaceSymbolOnId(symName: string, deleteCount: number, symId: number): StateReelSymbol {
        const newSymbol: StateReelSymbol = this.addNewSymbol(symName);
        const removedSymbolArr = this.allSymbols.splice(symId + 1, deleteCount, newSymbol);
        this._reelView.addChild(removedSymbolArr[0]);
        newSymbol.y = removedSymbolArr[0].y;
        this.removeSymbol(removedSymbolArr[0]);
        return newSymbol;
    }

    /*playing  X  expansion on Landing X Animation Complete*/
    public playXLandingAnimation(): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        const symId = this.gameData.XSymbolPositions[this.reelId];
        const sizeAfterMystery = 4 + this.gameData.mysterySymbolSizes[this.reelId] - 1;
        const reelId = this.reelId;
        const mSize = this.gameData.mysterySymbolSizes[reelId];
        let symbolHeight = HorribleHeroesReelController.SYM_SIZE[sizeAfterMystery].height;
        let afterstackPosY = 0;
        if (mSize == 2) {
            afterstackPosY = ((symId + 1) * symbolHeight);
        } else {
            afterstackPosY = ((symId + 1) * symbolHeight) + symbolHeight / 2;
        }
        tl.add(() => {
            if (this.xWayExpand[this.reelId]) {
                let shiftY: number = Helper.getSymbolPositionsOnReelArea(reelId, symId)[1] - afterstackPosY;
                const xSym: HorribleHerosXSymbol = (Reels.getSymbol(reelId, symId)! as HorribleHerosXSymbol);
                xSym.setMayhemMode(this.gameData.isSuperActivatedSpin && !this.gameData.superFSTriggered);
                //#335
                xSym.playExpandingAnimation(symbolHeight, mSize, shiftY, symId, 147);
                xSym.playExtraLandingAnimations();

                this.adjustSymbolsOnReel(reelId, symId, mSize, symbolHeight);
            }
        }, 0);
        return tl;
    }

    public replaceWithExpandedXSymbol(reelId: number, sizeAfterMystery: number, symId: number, mSize: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();
        if (this.gameData.bonusPositions[reelId] > -1 && this.gameData.isXWayExpanded.filter(Boolean).length > 0 || this.gameData.mode.indexOf("FREESPIN") > -1) {
            this.playInfectiousAnimation(reelId);
        }
        if (this.xWayExpand[this.reelId]) {
            HorribleHeroesGameModuleConfig.reelBackGroundView.updateXWays(this.reelId);
            this.addExpandingSymbols("X", this.gameData.mysterySymbolSizes[this.reelId], symId);
            if (sizeAfterMystery > 4) {
                this._reelSize = sizeAfterMystery;
            } else {
                this._reelSize = 4;
            }
            const symbolHeight: number = HorribleHeroesReelController.SYM_SIZE[this._reelSize].height;
            /*W already landed so when x lands already green*/
            if (this.checkIfWLanded(reelId, this.gameData.bonusPositions) || this.gameData.mode.indexOf("FREESPIN") > -1) {
                (Reels.getSymbol(reelId, symId)! as HorribleHerosXSymbol)!.playSaberAnimation(mSize, symbolHeight / 2);
                (<HorribleHerosXSymbol>Reels.getSymbol(reelId, symId))!.setMayhemMode(this.gameData.isSuperActivatedSpin && !this.gameData.superFSTriggered);
                (<HorribleHerosXSymbol>Reels.getSymbol(reelId, symId))!.updateBackground(symbolHeight * mSize, true);
            }
            HorribleHeroesGameModuleConfig.symbolWinAnimation.playThunderAnimation(reelId, symId, mSize, sizeAfterMystery);
        }
        tl.add(() => {
        }, 0.1);
        return tl;
    }

    /**
     * @description overridden to add trail to Xsymbols during spin in Mayhemmode
     * @param previousSymbol
     * @param init
     */
    //#395
    protected createNextSymbol(previousSymbol?: StateReelSymbol | null, init?: boolean): StateReelSymbol {
        const retVal: StateReelSymbol = super.createNextSymbol(previousSymbol, init);

        if ((retVal.symName === "X") && HorribleHeroesReelController.isMayhemMode) {
            (<TrailReelSymbol>retVal).changeState({state: HorribleHeroesGameConfig.instance.SYMBOL_STATES.mayhem});
            (<TrailReelSymbol>retVal).playTrailOverlay();
            this._trailingSym = "X";
        }
        if ((retVal.symName === "W") && HorribleHeroesReelController.isLockNLoad) {
            (<TrailReelSymbol>retVal).playTrailOverlay();
            this._trailingSym = "W";
        }

        if (HorribleHeroesReelController.isMayhemMode || HorribleHeroesReelController.isLockNLoad) {
            if (this._trailingSym.length > 0) {
                (retVal as HorribleHeroesReelSymbol).placeSymsBelowTrailingSymbol(this._trailingSym);
            }
            //#395 for every symbol created after trailing sym
        }
        return retVal;
    }

    /**
     * @inheritDoc
     * @override To re-order the symbols.
     */
    protected initReelStrip(): void {
        super.initReelStrip();
        if (!this._reelInitialized) {
            return;
        }

        this.reOrderSymbols();
    }

    protected onSpinStepCompleted(): void {
        (<HorribleHeroesSpinReelPartAnimator>this._reelPartAnimator).setReelSize(this._finalXReelSize);
        this._reelSize = this._finalXReelSize;
        super.onSpinStepCompleted();
    }

    protected onSpinStartedCompleted(): void {
        super.onSpinStartedCompleted();
        (<HorribleHeroesSpinReelPartAnimator>this._reelPartAnimator).resetReelSize(HorribleHeroesReelController.SYM_SIZE[4].height);
        if (this.gameData && !HorribleHeroesReelController.isResponseReceived) {
            //#434  should check as per previous spin response
            const isNextModeFS: boolean = (this.gameData.nextMode !== HorribleHeroesGameMode.NORMAL);
            if (this.gameData.isSuperActivatedSpin && this.gameData.superFSTriggered && isNextModeFS) {
                HorribleHeroesReelController.isMayhemMode = true;
                EventHandler.dispatchEvent(new GameEvent(SpinReelEvent.REEL_SET_CURRENT_REEL_SET, {
                    reelSetName: "SUPERFS_REELSET",
                    reelSetPosition: 2
                }));
            }
        }
        if (this.gameData) {
            HorribleHeroesReelController.isLockNLoad = (this.gameData.nextMode === HorribleHeroesGameMode.FREESPIN_MID);
        }
    }

    protected onSpinStopAnimationCompleted(): void {
        const reelId: number = this._reelId;
        HorribleHeroesReelController.isMayhemMode = false;
        // #430 => middle 3 reels in FS Low mode only
        if (this._gameMode === HorribleHeroesGameMode.FREESPIN_LOW && reelId > 0 && reelId < 4) {
            HorribleHeroesGameModuleConfig.randomWildView.replaceWildSymbolInFSLow(reelId);
        }

        super.onSpinStopAnimationCompleted();
        //#434
        HorribleHeroesReelController.isResponseReceived = false;
        const tl: TimelineLite = new TimelineLite();
        const symId: number = this.gameData.XSymbolPositions[this.reelId];
        const sizeAfterMystery: number = 4 + this.gameData.mysterySymbolSizes[this.reelId] - 1;
        const mSize: number = this.gameData.mysterySymbolSizes[reelId];
        tl.add(() => {
            if (this.xWayExpand[reelId]) {
                (<HorribleHeroesReelController>Reels.getReel(reelId)).playXLandingAnimation();
            }
        });
        tl.add(() => {
            if (this.xWayExpand[reelId]) {
                (Reels.getSymbol(reelId, symId)! as HorribleHerosXSymbol)!.quickExpansion();
            }
            this.replaceWithExpandedXSymbol(reelId, sizeAfterMystery, symId, mSize)
        }, 0.12);
        if (reelId === 4 && !(this.calculateScatterCount() >= 3)) {
            if (!(this.gameData.mode == HorribleHeroesGameMode.FREESPIN_LOW || (this.gameData.mode == HorribleHeroesGameMode.FREESPIN_MID))) { // go back to level1
                HorribleHeroesGameModuleConfig.background.playFireAnimationLevel("1");
                HorribleHeroesGameModuleConfig.reelBackGroundView.playChainAnimation("1");
            }
        }
    }

    /**
     * @inheritDoc
     * @param data
     */
    protected parseInitData(data: HorribleHeroesParsedInitData): void {
        super.parseInitData(data);
        this._reelSize = 4;
        this._finalXReelSize = this._reelSize;
        (<HorribleHeroesSpinReelPartAnimator>this._reelPartAnimator).setReelSize(this._reelSize);
    }

    protected makeUpStopReelSet(bottomFillUpTotalNum: number, init: boolean): string[] {
        // #377, #425
        const isRestore: boolean = HorribleHeroesGameModuleConfig.stickyWilds.isRestore(),
            isNextModeNormal: boolean = HorribleHeroesGameModuleConfig.stickyWilds.getNextMode() === HorribleHeroesGameMode.NORMAL,
            isLockedWildNextSpin: boolean[][] = HorribleHeroesGameModuleConfig.stickyWilds.getStickyWildPositions(),
            isWildLanded: boolean = HorribleHeroesGameModuleConfig.stickyWilds.hasNewStickyWildLandedOnReel(this._reelId),
            wildPositions: number[] = [];

        if ((!init || isRestore) && this._reelId > 0 && this._reelId < 4) {
            // modified in #430, #464
            if ((this._gameMode === HorribleHeroesGameMode.FREESPIN_LOW && HorribleHeroesGameModuleConfig.randomWildView.blastPlayed) || ((!isNextModeNormal) && !isWildLanded && isLockedWildNextSpin && isLockedWildNextSpin[this.reelId].indexOf(true) > -1)) {
                for (let i: number = 1; i < this._stopReelSet.length - 1; i++) {
                    if (this._stopReelSet[i] === "W") {
                        this._stopReelSet[i] = "L1";

                        wildPositions.push(i);
                    }
                }
            }
        }

        const retVal: string[] = super.makeUpStopReelSet(bottomFillUpTotalNum, init);

        // resetting it back, since it affects the "reels" object.
        for (let i: number = 0; i < wildPositions.length; i++) {
            this._stopReelSet[wildPositions[i]] = "W";
        }

        return retVal;
    }

    private adjustSymbolsOnReel(reelId: number, xPos: number, mSize: number, symbolHeight: number): void {
        for (let symId: number = 0; symId < 4; symId++) {
            let adjustingSym: number = symId;
            if (symId > xPos) {
                adjustingSym = symId + mSize - 1;
            }
            symId !== xPos && (Reels.getSymbol(reelId, symId)! as HorribleHeroesReelSymbol)!.adjustSize(symbolHeight, adjustingSym);
            if (this.gameData && this.gameData.getEvaluatedArea()[reelId][symId] === "W") {
                const reelSizeAfterX: number = 4 + mSize - 1;
                const posY: number = ((adjustingSym) * symbolHeight) + symbolHeight / 2;
                HorribleHeroesGameModuleConfig.stickyWilds.onSymHeightChange(reelId, symId + 1, mSize, reelSizeAfterX, posY, true);
                /*556to play FS when X and W lands together sending showPlusFStrue*/
            }
        }
    }

    private checkIfWLanded(reelId: number, wPosArr: number[]): boolean {
        let isWildLanded: boolean = false;
        wPosArr.forEach((value: number, reID: number) => {
            if (value >= 0 && reID < reelId) {
                isWildLanded = true;
            }
        });
        return isWildLanded;
    }

    private parseReelSize(gameAreaSize: number): void {
        this._reelSize = gameAreaSize;
        (<HorribleHeroesSpinReelPartAnimator>this._reelPartAnimator).setReelSize(this._reelSize);
        this.initAnimator();
    }

    /**
     * @description resetAllSizes
     * @param HIGHMSYMS - symName ARR,
     * @param symToReplace - symName,
     * @param symbolHeight - number,
     * @param mysterySymbolSize -length
     * @param mysterySymbolIdInStopSymbols -position on reel
     * @param isInfectious -boolean
     * @param isStack -boolean
     */
    private resetAllSizes(HIGHMSYMS: string[], symToReplace: string, symbolHeight: number, mysterySymbolSize: number, mysterySymbolIdInStopSymbols: number, isInfectious?: boolean, isStack?: boolean): void {
        (<HorribleHeroesSpinReelPartAnimator>this._reelPartAnimator).setAllSymbols(this.allSymbols.map(s => s!));
        if (HIGHMSYMS.indexOf(symToReplace) !== -1 && symToReplace !== "X") {
            (<HorribleHeroesSymbolM>Reels.getSymbol(this.reelId, mysterySymbolIdInStopSymbols)).patchMultiplier(mysterySymbolSize);
        }
        (<HorribleHeroesSpinReelPartAnimator>this._reelPartAnimator).resetSize(symbolHeight, true, mysterySymbolIdInStopSymbols, mysterySymbolSize);

    }

    /**
     * @description updateStackSyms change State,visiblity,,position low/high  of symbols
     * @param HIGHMSYMS - symName ARR,
     * @param symToReplace - symName,
     * @param mysterySymbolSize - size of Stack,
     * @param mysterySymbolIdInStopSymbols - -position on reel,
     * @param newSymbol - stackedSymbol,
     * @param lastIndex -number
     */
    private updateStackSyms(HIGHMSYMS: string[], symToReplace: string, mysterySymbolSize: number, mysterySymbolIdInStopSymbols: number, newSymbol: StateReelSymbol, mysterySymIndex: number, lastIndex: number): void {
        const secIndex = mysterySymbolIdInStopSymbols + mysterySymIndex;
        if (HIGHMSYMS.indexOf(symToReplace) !== -1) {
            this.updateStackedSymbols(newSymbol, this.allSymbols[secIndex - 1], 1, true);
            if (mysterySymIndex == (mysterySymbolSize - 1)) {
                if (this.allSymbols[lastIndex]) this.allSymbols[lastIndex].visible = true;
            } else {
                if (this.allSymbols[secIndex]) this.allSymbols[secIndex].visible = false;
            }
        }
    }

    /**
     * @description addAndRemoveSyms
     * @param i -  number,
     * @param newSymbol - StateReelSymbol,
     * @param mysterySymbolIdInStopSymbols - -position on reel,
     * @param deleteCount - number,
     */
    private addAndRemoveSyms(i: number, newSymbol: StateReelSymbol, mysterySymbolIdInStopSymbols: number, deleteCount: number): void {
        if (deleteCount) {
            const removedSymbolArr = this.allSymbols.splice(mysterySymbolIdInStopSymbols, deleteCount, newSymbol);
            this.removeSymbol(removedSymbolArr[0]);
        } else {
            this.allSymbols.splice(mysterySymbolIdInStopSymbols, deleteCount, newSymbol);
            const removedSymbol: StateReelSymbol = this.allSymbols.pop()!;
            if (removedSymbol)
                this.removeSymbol(removedSymbol);
        }
    }

    private playInfectiousAnimation(reelId: number): void {
        for (let rd = reelId; rd >= 0; rd--) {
            if (this.gameData.XSymbolPositions[rd] > -1 && rd < reelId) {//default it is -1
                if (Reels.getSymbol(rd, this.gameData.XSymbolPositions[rd])!.symName.indexOf("X") !== -1) {
                    const reelSize = (<HorribleHeroesReelController>Reels.getReel(rd))._reelSize;
                    const symbolHeight: number = HorribleHeroesReelController.SYM_SIZE[reelSize].height;
                    (Reels.getSymbol(rd, this.gameData.XSymbolPositions[rd])! as HorribleHerosXSymbol)!.playSaberAnimation(this.gameData.mysterySymbolSizes[rd], symbolHeight / 2);
                    (<HorribleHerosXSymbol>Reels.getSymbol(rd, this.gameData.XSymbolPositions[rd]))!.updateBackground(symbolHeight * this.gameData.mysterySymbolSizes[rd], true);
                }
            }
        }
        return;
    }

    /**
     * @description to convert infected X's into X2/X3 or X2/X3 to revealed Symbol
     * @param newSymName - string,
     * @param finalReelSize - number,
     * @param mysterySymbolSize -length
     * @param mysterySymbolIdInStopSymbols - index,
     */
    private addStackSyms(newSymName: string, finalReelSize: number, mysterySymbolSize: number, mysterySymbolIdInStopSymbols: number): void {
        let highSymName = newSymName;
        const StackSyms = HorribleHeroesGameConfig.instance.HIGHMSYMS.concat(["X"]);
        this.parseReelSize(finalReelSize);
        const symbolStep: number = HorribleHeroesReelController.SYM_SIZE[this._reelSize].height;
        // Replace symbol and add more symbols
        for (let i: number = 0; i < mysterySymbolSize; i++) {
            if (StackSyms.indexOf(newSymName) !== -1) {
                highSymName = newSymName + "_" + (mysterySymbolSize) + '*' + i;
            }
            const newSymbol: StateReelSymbol = this.addNewSymbol(highSymName);
            if (i == 0 || (this.allSymbols[mysterySymbolIdInStopSymbols + i].symName.length > 2 && this.allSymbols[mysterySymbolIdInStopSymbols + i].symName[0] == "X")) {
                const removedSymbolAr = this.allSymbols.splice(mysterySymbolIdInStopSymbols + i, 1, newSymbol);
                //with  new behaviour only X stack is going to be replaced
                this.removeSymbol(removedSymbolAr[0]);
            } else {
                this.allSymbols.splice(mysterySymbolIdInStopSymbols + i, 0, newSymbol);
                const removedSymbol: StateReelSymbol = this.allSymbols.pop()!;
                this.removeSymbol(removedSymbol);
            }
            if (StackSyms.indexOf(newSymName) !== -1) {
                this.updateStackedSymbols(newSymbol, this.allSymbols[mysterySymbolIdInStopSymbols + i - 1], 1, true);
                newSymbol.y = ((mysterySymbolIdInStopSymbols) * symbolStep);
                if (mysterySymbolSize !== 2) {
                    if (newSymbol!.symName.split("_")[1]) {
                        const stackIndex = newSymbol!.symName.split("_")[1].split("*")[1];
                        const stackSize = newSymbol!.symName.split("_")[1].split("*")[0];
                        if (stackSize == "2") {
                            newSymbol.y = (mysterySymbolIdInStopSymbols + i - parseInt(stackIndex)) * symbolStep;
                        } else {
                            newSymbol.y = (mysterySymbolIdInStopSymbols + i - parseInt(stackIndex)) * symbolStep + symbolStep / 2;
                        }
                    }
                }
                if (newSymbol.symName.indexOf("X") > -1 && newSymbol.symName.indexOf("M") === -1) {
                    (newSymbol! as HorribleHerosXSymbol).setMayhemMode(this.gameData.isSuperActivatedSpin && !this.gameData.superFSTriggered);
                    //#335
                }
                newSymbol.symHeight = symbolStep * mysterySymbolSize;
                newSymbol.visible = true;
                if (i == (mysterySymbolSize - 1)) {
                    this.allSymbols[mysterySymbolIdInStopSymbols + mysterySymbolSize - 1].visible = true;
                    (<HorribleHeroesSymbolM>Reels.getSymbol(this.reelId, mysterySymbolIdInStopSymbols)).patchMultiplier(mysterySymbolSize);
                } else {
                    this.allSymbols[mysterySymbolIdInStopSymbols + i].visible = false;
                }

            } else {
                newSymbol.symHeight = symbolStep;
                newSymbol.visible = true;
                newSymbol.position.set(0, (mysterySymbolIdInStopSymbols + i - 1) * symbolStep + symbolStep / 2);
            }
        }
    }

    /*
    * @description calculateScatterCount till current reelStop
    */
    private calculateScatterCount(): number {
        let scattercount: number = 0;
        this.gameData.scatterPositions!.forEach((sctterpos: number, index: number) => {
            if (index <= this._reelId) {
                if (sctterpos > -1) {
                    scattercount++;
                }
            }
        });
        return scattercount;
    }
}